
(function (Drupal) {
  Drupal.behaviors.forceSticky = {
    attach: function (context) {
      once('forceStickyActive', 'html', context).forEach(function(el) {
        Stickyfill.forceSticky();
//        console.log('forceStickyActive');
      });

      once('stickyFillAdded', '.force-sticky', context).forEach(function(el) {
//        var element_list = document.querySelectorAll('.force-sticky:not([data-once=stickyFillAdded])');
        Stickyfill.addOne(el)
//        console.log('stickyFillAdded (not)?', el);
      });
    }
  }
})(Drupal);
